import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';
import traintime from '../lib/TrainTime';

const defaults = {
    id: null,
    text: null,
    startDate: null,
    endDate: null
};

class Banner extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(Banner, json, {
            id: fields.string,
            text: fields.string,
            startDate: fields.datetime,
            endDate: fields.datetime
        });
    }

    isActive () {
        const now = traintime();
        if (this.startDate && this.endDate) {
            return now.isBetween(this.startDate, this.endDate);
        }
        return false;
    }

}


export default Banner;
